module.exports = __webpack_public_path__ + "img/logo-zc-dark.4936cdf7.png";